import { render, staticRenderFns } from "./frontend_master.vue?vue&type=template&id=8499af42"
import script from "./frontend_master.vue?vue&type=script&lang=js"
export * from "./frontend_master.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.104.1__lodash@4.17.23_vue-template-compiler@2.7.16_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports